import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { forkJoin, finalize } from 'rxjs';
import { PresentmentDetail, PresentmentHeader, ReconciliationApi } from '../../core/reconciliation-api';
import { dateTime, moneyFromCents, text } from '../../shared/formatters';
import { PageNavigation } from '../../shared/page-navigation/page-navigation';

@Component({ selector: 'app-gp-presentment-detail', imports: [CommonModule, FormsModule, RouterLink, PageNavigation], templateUrl: './gp-presentment-detail.html' })
export class GpPresentmentDetail implements OnInit {
  readonly pageSizes = [25, 50, 100];
  readonly text = text; readonly dateTime = dateTime; readonly moneyFromCents = moneyFromCents;
  headerId = 0; header?: PresentmentHeader; rows: PresentmentDetail[] = [];
  page = 0; size = 25; total = 0; totalPages = 1; loading = false; error = '';

  constructor(private readonly route: ActivatedRoute, private readonly api: ReconciliationApi, private readonly cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.headerId = Number(this.route.snapshot.paramMap.get('headerId'));
    if (!Number.isInteger(this.headerId) || this.headerId <= 0) { this.error = 'El identificador del header no es válido.'; return; }
    this.load(true);
  }

  load(includeHeader = false): void {
    this.loading = true; this.error = '';
    const details = this.api.getPresentmentDetails(this.headerId, this.page, this.size);
    const request = forkJoin({ header: this.api.getPresentmentHeader(this.headerId), details });
    request.pipe(finalize(() => { this.loading = false; this.cdr.markForCheck(); })).subscribe({
      next: result => {
        this.header = result.header;
        this.rows = result.details.content ?? []; this.total = result.details.totalElements ?? 0; this.totalPages = Math.max(1, result.details.totalPages ?? 1); this.cdr.markForCheck();
      },
      error: () => { this.error = 'No se pudo cargar el detalle de la presentación.'; this.cdr.markForCheck(); }
    });
  }
  previous(): void { if (this.page > 0 && !this.loading) { this.page--; this.load(); } }
  next(): void { if (this.page + 1 < this.totalPages && !this.loading) { this.page++; this.load(); } }
}
